import React from "react";
import { useNavigate } from "react-router-dom";
import { Activity, Home, GraduationCap, X } from "lucide-react";

function Modal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const options = [
    {
      id: "healthcare",
      title: "Healthcare",
      icon: <Activity className="w-12 h-12 text-[#3E88FF]" />,
      path: "/interactive-healthcare",
      color: "border-[#3E88FF]",
      bg: "bg-[#3E88FF]/5"
    },
    {
      id: "realestate",
      title: "Real Estate",
      icon: <Home className="w-12 h-12 text-[#FF3E3E]" />,
      path: "/interactive-realestate",
      color: "border-[#FF3E3E]",
      bg: "bg-[#FF3E3E]/5"
    },
    {
      id: "education",
      title: "Education",
      icon: <GraduationCap className="w-12 h-12 text-indigo-500" />,
      path: "/interactive-education",
      color: "border-indigo-500",
      bg: "bg-indigo-500/5"
    }
  ];

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-[100] p-4 transition-all duration-300">
      <div className="bg-white rounded-3xl shadow-2xl relative w-full max-w-4xl p-8 overflow-hidden transform animate-in fade-in zoom-in duration-300">

        {/* Close Button */}
        <button
          className="absolute top-6 right-6 p-2 rounded-full hover:bg-gray-100 transition-colors text-gray-500 hover:text-black"
          onClick={onClose}
        >
          <X className="w-6 h-6" />
        </button>

        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4 tracking-tight">
            Choose Your <span className="text-[#3E88FF]">Form</span>
          </h2>
          <p className="text-gray-500 max-w-lg mx-auto text-lg">
            Please select the sector you want to proceed with and we'll take you to the interactive assessment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {options.map((option) => (
            <div
              key={option.id}
              onClick={() => {
                navigate(option.path);
                onClose();
              }}
              className={`group cursor-pointer p-8 rounded-2xl border-2 ${option.color} ${option.bg} transition-all duration-300 hover:-translate-y-2 hover:shadow-xl flex flex-col items-center justify-center text-center`}
            >
              <div className="mb-6 p-4 bg-white rounded-2xl shadow-sm group-hover:scale-110 transition-transform duration-300 border border-gray-100">
                {option.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2 transition-colors">
                {option.title}
              </h3>
              <p className="text-gray-500 text-sm opacity-80">
                Click to start the interactive funnel
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-gray-100 text-center">
          <p className="text-sm font-black tracking-widest text-slate-400">
            DUMOSH<span className="text-[#FF3E3E]">.</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Modal;
